module.exports = "<main id=\"mn-about\">\n\n  <h1><p>About</p>\n    <p>Alexander</p>\n    <p>Kushchov</p></h1>\n  <div class=\"pict\">\n\n  </div>\n  <dl>\n    <dt>Purpose:</dt>\n    <dd>Be involved into interesting projects <br>Improve professional skills</dd>\n    <dt>Name:</dt>\n    <dd>Kushchov Alexander</dd>\n    <dt>Date of birth:\n    <dd>08.10.1985</dd>\n    <dt>Marital status:</dt>\n    <dd>Married</dd>\n  </dl>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/app/about/about.component.html
// module id = ../../../../../src/app/about/about.component.html
// module chunks = main